export default __webpack_public_path__ + "ab66112cac2ca46d6cf8501653479d36.woff2";